import { getQueryObject } from "../index";
import useRoutes from "../../hooks/routeHooks";
import { getLicenceListByLocationId } from "../../store/licenceStore/licenceRequests";
import { GeneralRequest } from "../../requests/GeneralRequest";
import { requestLocationByQuery } from "../../store/locationStore/locationRequests";
import { setCurrentLocationId } from "../../store/locationStore/locationState";
import PageUpdater from "../../containers/PageUpdater";
import { setCurrentLicenceId } from "../../store/licenceStore/licenceState";
import { ThreeColumnLayout } from "../../layouts/ThreeColumnLayout/ThreeColumnLayout";
import LicenceList from "../../containers/LicenceList";
import LicenceCentralPanel from "../../containers/LicencePage/LicenceCentralPanel";
import {
  requestAllTechnologyConfigurations,
} from "../../store/technologyConfigurationStore/technologyConfigurationRequests";
import LicenceRightPanel from "../../containers/LicencePage/LicenceRightPanel";

const LicencePage = () => {
  const urlProps = getQueryObject();
  const { actions } = useRoutes();
  const locationId = parseInt(urlProps.locationId as string, 10);

  if (!locationId || isNaN(locationId)) {
    actions.redirectWrongId();
    return null;
  }

  return (
    <>
      <GeneralRequest requestAction={requestLocationByQuery}>
        <GeneralRequest
          requestAction={getLicenceListByLocationId}
          requestArguments={[ locationId ]}
        >
          <PageUpdater
            watchItemList={[
              {
                title: 'locationId',
                action: setCurrentLocationId,
              },
              {
                title: 'licenceId',
                action: setCurrentLicenceId,
              },
            ]}
          />
          <GeneralRequest
            requestAction={requestAllTechnologyConfigurations}
          >
            <ThreeColumnLayout
              leftSideBar={<LicenceList currentLocationId={locationId} />}
              centerMainPanel={<LicenceCentralPanel />}
              rightSideBar={<LicenceRightPanel />}
            />
          </GeneralRequest>
        </GeneralRequest>
      </GeneralRequest>
    </>
  );
}

export default LicencePage;
